import { contato } from '../data/conteudo';
import { IconeEmail, IconeInstagram } from './Icones';
import styles from './Rodape.module.css';

const Rodape = () => (
  <footer className={styles.rodape}>
    <div className={`container ${styles.barra}`}>
      <p>
        <strong>{contato.nome}</strong>
        <br />
        {contato.titulo}, {contato.crp}
      </p>
      <div className={styles.redes}>
        <a
          href={`https://www.instagram.com/${contato.instagram}/`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <IconeInstagram />
        </a>
        <a href={`mailto:${contato.email}`} aria-label="Enviar e-mail">
          <IconeEmail />
        </a>
      </div>
    </div>
    <div className="container">
      <p className={styles.direitos}>© {new Date().getFullYear()} {contato.nome}. Todos os direitos reservados.</p>
    </div>
  </footer>
);

export default Rodape;
